import _ from 'lodash'
import { createSelector } from 'reselect'
import { getHomeDocumentsList } from './Lists'

export const groupHomeDocuments = createSelector(
  [getHomeDocumentsList],
  (documents) => {
    return _.chain(documents).groupBy('categoryName').value()
  }
)
